import React, { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux";
import { onOpenPopup } from "../../Containers/RightPanelAction";
import Type from "../../Redux/Type";
import { ActionButton } from "../Accessary";
import '../../Styles/tabmap.css'
import PopupContentBar from './PopupPanel';
import { useEffect } from "react";
import { Checkbox, Stack, TooltipHost } from '@fluentui/react';
import COLOR from "../../Styles/Colors";
import { onShowOffQuyHoachInfoPanel } from "../../Containers/QuyHoach";

const TabOptionTop = () => {
    const userInfo = useSelector(state => state.userInfo);
    const dispatch = useDispatch();
    const { showTool, keyActive } = useSelector(state => state.drawingTool);
    const { routeContent } = useSelector(state => state.popupPanel);
    const { loadingSearch } = useSelector(state => state.searchState);
    const { isLoading } = useSelector(state => state.quyHoach);
    const { showThuaDat } = useSelector(state => state.hienTrang);
    // const { popupContent } = useSelector(state => state.popupContent);

    const onButtonPress = (route) => () => {
        if (keyActive === route) {
            dispatch({ type: Type.SHOW_KEY_ACTIVE, evt: "" });
        } else {
            dispatch({ type: Type.SHOW_KEY_ACTIVE, evt: route });
        }

        // Off Ve Quy Hoach
        if (showTool) {
            dispatch({ type: Type.CLEAR_PATH_DRAWING });
            dispatch({ type: Type.SHOW_OFF_DRAWING });
        }
        onOpenPopup(route)
    }
    const onButtonPress2 = (route) => () => {

        // onOpenPopup(route)
        //console.log(route)
        //onButtonPress(route)
        onOpenPopup(route)
    }
    const onDrawingPress = () => {

        if (showTool) {
            dispatch({ type: Type.CLEAR_PATH_DRAWING });
            dispatch({ type: Type.SHOW_OFF_DRAWING });
        }
        else {
            dispatch({ type: Type.SET_MODE_DRAWING, evt: 'polygon' });
            dispatch({ type: Type.START_DRAWING, evt: 'polygon' })
            dispatch({ type: Type.SHOW_ON_DRAWING });
        }
        if (keyActive == 'vequyhoach') {
            dispatch({ type: Type.SHOW_KEY_ACTIVE, evt: "" });
        } else {
            dispatch({ type: Type.SHOW_KEY_ACTIVE, evt: "vequyhoach" });
        }

        // off Tab
        dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'routeContent', value: null });
        dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'isShowForPopup', value: false });
    }

    useEffect(() => {
        let customtop = document.getElementById('custom-top-bar')
        let widthWin = window.innerWidth
        let widthCus = customtop.offsetWidth
        let fromLeft = (widthWin / 2) - (widthCus / 2)
        customtop.style.left = `${fromLeft}px`
    })

    const onChangeShowThuaDatStatus = () => {
        if (!showThuaDat) {
            onShowOffQuyHoachInfoPanel()
            dispatch({ type: Type.SET_STATE_QUY_HOACH, route: 'showQuyHoach', value: false });
        }
        dispatch({ type: Type.SET_STATE_HIEN_TRANG, route: 'showThuaDat', value: !showThuaDat });
    };


    return (
        <Fragment>
            {/* <div id="humberger-button">
                <nav>
                    <div className="navbarv">
                        <div className="container nav-container">
                            <input className="checkbox" type="checkbox" name="" id="" />
                            <div className="hamburger-lines">
                                <span className="line line1"></span>
                                <span className="line line2"></span>
                                <span className="line line3"></span>
                            </div>
                            <div className="logo">
                                <h1>Navbar</h1>
                            </div>
                            <div className="menu-items">
                                {appButton.map(item => (
                                    <li>
                                        <a onClick={() => { onButtonPress(item.key) }}>{item.tooltip}</a>
                                    </li>
                                ))}

                            </div>
                            <PopupContentBar />
                        </div>
                    </div>
                </nav>
            </div> */}
            <div id="custom-top-bar">
                {/* {userInfo ?
                    <ActionButton
                        iconName={'EditCreate'}
                        tooltip={'Vẽ quy hoạch'}
                        checkQuyHoach={keyActive === 'vequyhoach'}
                        title={'Vẽ quy hoạch'}
                        onClick={onDrawingPress}
                    />
                    : null
                } */}
                {/* <TooltipHost
                    content={"Chọn xem lớp thử đất"}
                >
                    <Stack style={styles.btnLopThuaDat} >
                        <Checkbox
                            onChange={onChangeShowThuaDatStatus}
                            checked={showThuaDat}
                            styles={styles.checkLopThuaDat}
                            label="Lớp thửa đất" />
                    </Stack>
                </TooltipHost> */}

                <ActionButton
                        //key={item.key}
                        iconName={showThuaDat ? "BoxCheckmarkSolid" : "Checkbox" }
                        tooltip={"Chọn xem lớp thử đất"}
                        //checkQuyHoach={keyActive === item.key}
                        title={"Lớp thửa đất"}
                        text={"Lớp thửa đất"}
                        onClick={onChangeShowThuaDatStatus}
                        disabled={isLoading || loadingSearch}
                    />

                {appButton.map(item => (
                    <ActionButton
                        key={item.key}
                        iconName={item.iconName}
                        tooltip={item.tooltip}
                        checkQuyHoach={keyActive === item.key}
                        title={item.tooltip}
                        text={item.text}
                        onClick={onButtonPress(item.key)}
                        disabled={isLoading || loadingSearch}
                    />
                ))}
                <PopupContentBar />
            </div>
        </Fragment>
    )
}
export default TabOptionTop;
//BoxCheckmarkSolid
//Checkbox
const appButton = [
    { key: 'search', iconName: 'Search', tooltip: 'Tìm kiếm thửa đất', text: 'Tìm kiếm', mustLogin: true },
    { key: 'layer', iconName: 'MapLayers', tooltip: 'Bản đồ quy hoạch - kế hoạch sử dụng đất', text: 'Bản đồ', mustLogin: false }, //layer
    { key: 'location', iconName: 'List', tooltip: 'Chuyển vị trí đơn vị hành chính', text: 'Chuyển vị trí', mustLogin: false },
    { key: 'price', iconName: 'ImageSearch', tooltip: 'Bảng giá đất',text: 'Bảng giá đất', mustLogin: false },
];

const styles = {
    btnLopThuaDat: {
        backgroundColor: COLOR.white,
        marginRight: 10,
        padding: 5,
        borderRadius: 7,
        border: `1px solid #0078d4`,
        justifyContent: "center",
        alignItems: 'center',
        justifyItems: 'center'
    },
    checkLopThuaDat: {
        root: {
            justifyContent: "center",
            alignItems: "center",
            justifyItems: "center",
            alignContent: "center"
        },

        text: {
            color: '#0078d4'
        },
        checkbox: {
            width: 13,
            height: 13,
            marginTop: 3,
            border: `1px solid #0078d4`
        },
    }
}

